// extracted by mini-css-extract-plugin
export default {"Tab":"Tabs_Tab__y+-oh","Active":"Tabs_Active__LZtZF","Tabs":"Tabs_Tabs__zgKsD"};